import { Component } from '@angular/core';
import { LoaderService } from '../../services/loader.service';
import { Observable } from 'rxjs';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgIf, NgStyle, AsyncPipe } from '@angular/common';
@Component({
  selector: 'app-loader',
  imports: [MatProgressSpinnerModule, NgIf, NgStyle, AsyncPipe],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss'
})
export class LoaderComponent {


  loading$: Observable<boolean>;
  constructor(private loaderService: LoaderService) { }
  ngOnInit(): void {
    this.loading$ = this.loaderService.loading$; // Subscribe to loading state
  }
}
